/**************************************************************************************************************************************************
*   MODULE NAME     :  HomeActions
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  12-01-2021
*   DESCRIPTION     :  Dashboard API actions
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import * as types from "./actionTypes";
import HomeApi from "../api/HomeApi";

/******* ACTION OBJECTS *******/


/*****  ACTION DISPATCHERS  ******/

export const loadGlobalDashboardData = () => {
  return async () => {
    try {
      return await HomeApi.loadGlobalDashboard();
    } catch (error) {
      throw error;
    }
  }
};

export const loadGlobalDashboardDetails = (datatype, site, paginationData) => {
  return async () => {
    try {
      return await HomeApi.loadGlobalDashboardDetails(datatype, site, paginationData);
    } catch (error) {
      return error;
    }
  }
}

export const loadAllDashboardResults = (datatype, site) => {
  return async () => {
    try {
      return await HomeApi.loadAllDashboardResults(datatype, site);
    } catch (error) {
      return error;
    }
  }
}

export const sendGlobalDashboardEmail = (payload) => {
  return async () => {
    try {
      return await HomeApi.sendGlobalDashboardEmail(payload);
    } catch (error) {
      return error;
    }
  }
}

export const sendJapanDashboardEmail = (payload) => {
  return async () => {
    try {
      return await HomeApi.sendJapanDashboardEmail(payload);
    } catch (error) {
      return error;
    }
  }
}
